import * as React from 'react';
import { getSchema } from '../../../utils';
import { View } from '../../../types';
import { useSelector } from '../../../utils/useSelector';
import { ItemCard } from '../ItemCard/itemCard';
import { useDrag, useDrop } from 'react-dnd';
import { DragItem } from '../../../types/DragItem';
import { Field } from '../ItemCard/Field/field';

export interface EFSItemCardProps {
  group: View.Group;
  refId: string;
  index: number;
  moveItem: (dragIndex: number, hoverIndex: number) => void;
  efsTimeFrame: number;
  columnId: string;
  editMode: boolean;
}

export const EFSItemCard = ({
  group,
  refId,
  index,
  moveItem,
  efsTimeFrame,
  columnId,
  editMode
}: EFSItemCardProps) => {
  const view = useSelector(s => s.view?.selected);
  const item = useSelector(s => s.view.cards[refId]);
  const schemas = useSelector(s => s.planning?.selectedWorkspace?.schemas);
  const itemSchema = getSchema(schemas, item.labels);
  const name = useSelector(
    s => s.view?.efsItemData[item.props?.itemId]?.efsActionName
  );

  const [{ isDragging }, dragRef] = useDrag<
    DragItem,
    unknown,
    { isDragging: boolean }
  >({
    type: 'EFS_ITEM',
    item: { refId, efsTimeFrame, index, columnId },
    canDrag: () => !!efsTimeFrame,
    collect: monitor => ({
      isDragging: editMode && monitor.isDragging()
    })
  });

  const [{ isOver, canDrop }, dropRef] = useDrop<
    DragItem,
    unknown,
    { isOver: boolean; canDrop: boolean }
  >({
    accept: 'EFS_ITEM',
    canDrop: (draggedItem: DragItem) =>
      editMode &&
      draggedItem.columnId === columnId &&
      draggedItem.efsTimeFrame === efsTimeFrame,
    hover: (draggedItem: DragItem) => {
      if (
        editMode &&
        draggedItem.columnId === columnId &&
        draggedItem.efsTimeFrame === efsTimeFrame &&
        draggedItem.index !== index
      ) {
        moveItem(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    })
  });

  if (!itemSchema) console.log('Missing schema for item type', item.labels);

  const EFSTimeFrameDisplay = {
    30: '0-30 Days',
    60: '31-60 Days',
    90: '61-90 Days',
    365: '91+ Days'
  };

  return (
    <div
      ref={node => dragRef(dropRef(node))}
      className={`board-item ${isDragging ? 'dragging' : ''} ${
        canDrop ? 'droppable' : ''
      } ${!canDrop && isOver ? 'non-droppable' : ''}`}
    >
      <ItemCard item={item} group={group} view={view} displayName={name}>
        <Field
          label="EFS Time Frame"
          value={EFSTimeFrameDisplay[efsTimeFrame] || `-- `}
          fieldInfo={{ schemaField: {} } as any}
        />
      </ItemCard>
    </div>
  );
};
